import { ReactComponent } from './tipp-xl.svg';
export const TippIconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=tipp-xl.js.map